import {showErrorNotification, showSuccessNotification} from "../../global/notifications";
import getBodySettings from "../../global/page-settings";
import {loadSubContractAccrualData} from "./subcontract-accrual";
import {loadMaterialAccrual} from "./material-equipment-accrual";
import {closeKendoWindow} from "../../global/kendoWindows";

const {nameArea, nameController, nameAction, namePage} = getBodySettings('page');

const messages = {
    GoodsReceived: 'Latest Goods Received Date not clearly reflected',
    GoodsDate: 'Latest Goods Received Date After Year End',
    ServicesPerformed: 'Latest Services Performed not clearly reflected',
    ServicesDate: 'Latest Services Performed Date After Year End',
    DeliveryReflected: 'Latest Goods or Services to Date not clearly reflected',
    DeliveryDate: 'Latest Goods or Services Received to Date after Year End',
    ReflectedAmount: 'Dollar amount not clearly reflected',
    DollarAmountInput: 'Accrual Amount already included in posted invoices',
    AlreadyPosted: 'Accrual Amount already included in posted invoices',
    DollarVariance: 'Accrual Amount Variance >= $5,000',
    PercentageComplete: 'Percentage Complete not clearly reflected',
    PercentageVarianceInput: '',
    PercentageVariance: 'Percent Complete Variance >= $5,000'
};

const validMessages = {
    GoodsReceived: '',
    GoodsDate: 'Latest Goods Received Date Before Year End',
    ServicesPerformed: '',
    ServicesDate: 'Latest Services Performed Date Before Year End',
    DeliveryReflected: '',
    DeliveryDate: 'Latest Goods or Services Received To Date Before Year End',
    ReflectedAmount: '',
    DollarAmountInput: '',
    AlreadyPosted: '',
    DollarVariance: 'Variance < $5,000',
    PercentageComplete: '',
    PercentageVarianceInput: '',
    PercentageVariance: ''
};

let qid = 0;

export default function (quarterId) {
    qid = quarterId;
    attachQuestionEvents();
    attachSaveEvent();
    attachToggleApprovalEvent();
    setWindowData();

    $(document).trigger('on:PageUpdate');
}

/* Corporate Questions */
const addContactMessage = ($form, message) => {
    const $messages = $form.find('.js-contact-branch-messages');
    if ($messages.length) {
        //$('.js-audit-result').show();

        const $filtered = $messages.find('span').filter(function () {
            return ($(this).text() === message);
        });
        if (!$filtered.length) {
            $messages.append(`<span class="tag tag--red tag--small js-message" style="margin-left: 5px;">${message}</span>`);
        }
    }
};
const addValidMessage = ($form, message) => {
    const $messages = $form.find('.js-contact-branch-messages');
    if ($messages.length) {
        const $filtered = $messages.find('span').filter(function () {
            return ($(this).text() === message);
        });
        if (!$filtered.length) {
            $messages.append(`<span class="tag tag--green tag--small js-message" style="margin-left: 5px;">${message}</span>`);
        }
    }
};
const removeContactMessage = ($form, message) => {
    const $messages = $form.find('.js-contact-branch-messages');

    if ($messages.length) {
        const $tags = $messages.find('span');

        const $filtered = $tags.filter(function () {
            return ($(this).text() === message);
        });

        $filtered.remove();
    }
};
const removeValidMessage = ($form, message) => {
    const $messages = $form.find('.js-contact-branch-messages');

    if ($messages.length) {
        const $tags = $messages.find('span');

        const $filtered = $tags.filter(function () {
            return ($(this).text() === message);
        });

        $filtered.remove();
    }
};
const attachQuestionEvents = () => {
    const $corporateQuestions = $('[data-question]');
    $corporateQuestions.on('change', function () {
        const $self = $(this);
        const isVisible = $self.parent().is(":visible");
        const $form = $self.closest('form');
        const accrualId = $form.data('accrual-id');

        if ($self.length && isVisible) {
            const question = $self.data('question');
            const k_control = $self.data('kendoDropDownList') || $self.data('kendoDatePicker') || $self.data('kendoNumericTextBox');
            let showResponseFor = false;
            const $responseFor = $(`[data-response-for="${$self.data('question')}"]`);
            const value = k_control ? k_control.value() : $self.val();
            const message = messages[$self.data('message')];
            const validMessage = validMessages[$self.data('message')];
            switch (question) {
                case `GoodsReceived${accrualId}` :
                case `ServicesPerformed${accrualId}` :
                case `DeliveryReflected${accrualId}` : {
                    if (value === '0') {
                        addContactMessage($form, message);
                        hideQuestion($form, 'Q2');
                        hideQuestion($form, 'Q3');
                    } else {
                        showResponseFor = $responseFor.length && value === '1';
                        removeContactMessage($form, message)
                    }
                    break;
                }
                case `ReflectedAmount${accrualId}` : {
                    if (value === '0') {
                        const $alreadyPosted = $(`#AlreadyPosted${accrualId}`);
                        const k_alreadyPosted = $alreadyPosted.data('kendoDropDownList');
                        // Clear Value if kendoWidget exists
                        k_alreadyPosted && k_alreadyPosted.value('');

                        addContactMessage($form, messages[$responseFor.data('message')]);

                        showQuestion($form, 'Q3');

                        // Trigger change event
                        $alreadyPosted.change();

                        if (namePage === 'materialsequipmentaccrual') {
                            // Show message
                            addContactMessage($form, message);
                        }
                    } else {
                        hideQuestion($form, 'Q3');
                        removeContactMessage($form, messages[$responseFor.data('message')]);
                        showResponseFor = $responseFor.length && value === '1';
                        // Remove message
                        removeContactMessage($form, message);
                    }

                    $(`#PercentageComplete${accrualId}`).change();
                    break;
                }
                case `DollarAmountInput${accrualId}` : {
                    const $form = $self.parents('form');
                    const $originalAmount = $form.find('.js-dollar-amount-raw');
                    const $questionAmount = $form.find('[data-message=DollarAmountInput]');
                    const variance = Math.abs($originalAmount.val() - $questionAmount.val());

                    $form.find('.js-variance').text(kendo.toString(variance, 'c2'));
                    $form.find('.js-variance-raw').val(variance);

                    $form.find('[data-message=AlreadyPosted]').change();

                    break;
                }
                case `AlreadyPosted${accrualId}` : {
                    if (value === '1') {
                        addContactMessage($form, message);
                        hideQuestion($form, 'Q3');
                    } else {
                        removeContactMessage($form, message);
                        if (value === '0') {
                            showResponseFor = $responseFor.length;
                            const $form = $self.parents('form');
                            const variance = $form.find('.js-variance-raw').val();

                            if (variance >= 5000 && value !== '') {
                                removeValidMessage($form, validMessages[$responseFor.data('message')]);
                                addContactMessage($form, messages[$responseFor.data('message')]);
                            } else {
                                removeContactMessage($form, messages[$responseFor.data('message')]);
                                addValidMessage($form, validMessages[$responseFor.data('message')]);
                            }
                        }
                    }
                    break;
                }
                case `GoodsDate${accrualId}` :
                case `ServicesDate${accrualId}` :
                case `DeliveryDate${accrualId}` : {
                    let quarterDate = $('#quarter').data('kendoDropDownList').dataSource._data.filter(function (item) {
                        return Number(qid) === item.qid
                    })[0];

                    if (quarterDate) {
                        quarterDate = new Date(quarterDate.datestamp).addMonth(1);
                        if (new Date(value) >= quarterDate) {
                            addContactMessage($form, message);
                            hideQuestion($form, 'Q2');
                            hideQuestion($form, 'Q3');
                            removeValidMessage($form, validMessage);
                        } else {
                            removeContactMessage($form, message);
                            addValidMessage($form, validMessage);
                            showQuestion($form, 'Q2');
                        }
                    }
                    break;
                }
                case `PercentageComplete${accrualId}` : {
                    if (value === '0') {
                        let $reflectedAmount = $form.find('[data-message=ReflectedAmount]'),
                            k_reflectedAmount = $reflectedAmount.data('kendoDropDownList'),
                            $percentageVariance = $form.find('[data-message=PercentageVariance]'),
                            k_percentageVariance = null;

                        if (k_reflectedAmount && k_reflectedAmount.value() === '0' || $reflectedAmount.val() === '0') {
                            addContactMessage($form, message);
                        } else {
                            removeContactMessage($form, message);
                        }

                        if ($percentageVariance.length) {
                            k_percentageVariance = $percentageVariance.data('kendoNumericTextBox');
                            k_percentageVariance && k_percentageVariance.value('');
                            $percentageVariance.change();
                        }

                    } else {
                        removeContactMessage($form, message);
                        showResponseFor = $responseFor.length && value === '1';
                    }
                    break;
                }
                case `PercentageVariance${accrualId}` : {
                    let $form = $self.parents("form"),
                        $originalAmount = $form.find('.js-dollar-amount-raw'),
                        $originalPercent = $form.find('.js-original-percent-raw'),
                        $questionPercent = $form.find('[data-message=PercentageVariance]'),
                        $subContractAmount = $form.find('.js-total-subcontract'),
                        $openSubcontract = $form.find('.js-open-subcontract'),
                        cellDE39 = Number($self.val() / 100),
                        // variance = Math.abs($questionPercent.val() - $originalPercent.val()) / 100 * $originalAmount.val();
                        variance = (cellDE39 * $subContractAmount.val()) - ($subContractAmount.val() - $openSubcontract.val()) - $originalAmount.val();

                    showResponseFor = $responseFor.length && $questionPercent.val() !== '';

                    $form.find('.js-percent-variance').text(kendo.toString(variance, 'c2'));
                    $form.find('.js-percent-variance-raw').val(variance);

                    if (variance >= 5000 && $questionPercent.val() !== '') {
                        addContactMessage($form, message);
                    } else {
                        removeContactMessage($form, message);
                    }
                    break;
                }
            }

            if (showResponseFor) {
                $responseFor.parents('.js-response-wrapper').show();
            } else {
                removeContactMessage($form, messages[$responseFor.data('message')]);
                clearKendoControl($responseFor.data('kendoDatePicker') || $responseFor.data('kendoNumericTextBox'));
                $responseFor.parents('.js-response-wrapper').hide();
            }

            setAuditResultMessage($form, $form.find('.js-message.tag--red').length === 0);
        }
    });

    $('li.soxexc').on('click', function () {
        setTimeout(function () {
            //This is hacked bs and should be handled more elegantly on the backend
            // but due to change requirements and pressures for quick turn around, here we are
            $corporateQuestions.change();
        }, 500);
    });
};
const showQuestion = ($form, question) => {
    $form.find(`[data-question-top=${question}]`).show();
}
const hideQuestion = ($form, question) => {
    $form.find(`[data-question-top=${question}]`).hide();
}
const clearKendoControl = (k_control) => {
    k_control && k_control.value('');
};
const setAuditResultMessage = ($form, passed) => {
    const $result = $form.find('.js-result');
    const $resultMessage = $form.find('.js-result-message');
    const id = $form.attr('data-accrual-id');
    const $additionalInformation = $form.find('.js-additional-information-button');
    /*const baseQSelector = function (i) {
        let selector;
        switch (namePage) {
            case 'subcontractaccrual':
                selector = `#ServicesPerformed${i},#ReflectedAmount${i},#PercentageComplete${i}`;
                break;
            case 'materialsequipmentaccrual':
                selector = `#GoodsReceived${i},#ReflectedAmount${i}`;
                break;
            default:
                selector = '';
        }
        return selector;
    };*/
    // const baseQ = $(baseQSelector(id));

    if ($result.length) {
        if (passed && !endOfLineReached($result)) {
            $form.find('.js-audit-result').hide();
            $additionalInformation.hide();
        } else {
            $form.find('.js-audit-result').show();
            if (passed) {
                $form.find('.js-message.tag--green').show();
                $resultMessage.text('ACCRUAL IS VALID');
                $result.removeClass('k-i-warning').removeClass('--red');
                $result.addClass('k-i-check').addClass('--green');

                // Hide Comment and further Approval
                $form.find('.js-contact-branch-item').hide();
                $additionalInformation.hide();
            } else {
                $form.find('.js-message.tag--green').hide()
                $resultMessage.text('Contact Branch');
                $result.removeClass('k-i-check').removeClass('--green');
                $result.addClass('k-i-warning').addClass('--red');

                // Show Comment and Further approval
                $form.find('.js-contact-branch-item').show();
                $additionalInformation.show();
            }
        }
    }
};
const attachSaveEvent = () => {
    $('[data-role="save"]').on('click', function () {
        saveCorporateQuestions(this)
            .then(response => {
                showSuccessNotification(response);
            })
            .catch(error => {
                showErrorNotification(error);
            });
    })
}
export const saveCorporateQuestions = (self) => {
    return new Promise((resolve, reject) => {
        if ($('[data-role="save"]').length) {
            if (doQuestionValidation(self)) {
                $.post('/Account/Accruals/SaveCorporateQuestions', getFormData(self), function (response) {
                    if (response) {
                        resolve('Saved Responses');
                    } else {
                        reject('Error occured while saving responses');
                    }
                })
            } else {
                reject('Please complete all the questions');
            }
        } else {
            //Save Button is not available and was called by pm list so just resolve and move to next steps
            resolve();
        }
    })
}
const getFormData = (self) => {
    let $self = $(self),
        $form = $self.closest('form'),
        accrualId = $form.data('accrual-id');
    return {
        accrualId: accrualId,
        type: namePage,
        ApRef: accrualId,
        GoodsReceived: $form.find('[data-message=GoodsReceived]').val(),
        GoodsReceivedDate: $form.find('[data-message=GoodsDate]').val(),
        ServicesPerformed: $form.find('[data-message=ServicesPerformed]').val(),
        ServicesPerformedDate: $form.find('[data-message=ServicesDate]').val(),
        DeliveryReflected: $form.find('[data-message=DeliveryReflected]').val(),
        DeliveryDate: $form.find('[data-message=DeliveryDate]').val(),
        DollarAmountClear: $form.find('[data-message=ReflectedAmount]').val(),
        DollarAmount: $form.find('[data-message=DollarAmountInput]').val(),
        AlreadyIncluded: $form.find('[data-message=AlreadyPosted]').val(),
        DollarVariance: $form.find('.js-variance-raw').val(),
        PercentageCompleteClear: $form.find('[data-message=PercentageComplete]').val(),
        PercentageComplete: $form.find('[data-message=PercentageVariance]').val(),
        PercentageVariance: $form.find('.js-percent-variance-raw').val(),
        AuditorComments: $form.find('[name=AuditResults]').val(),
        Escalation: $form.find('input[id^=Escalation]').val()
    };
}
const attachToggleApprovalEvent = () => {
    $('[data-role="check_toggle"]').on('click', function () {
        let $form = $(this).closest('form'),
            accrualId = $form.data('accrual-id'),
            $documentationUploaded = $form.find(`#DocumentationUploaded${accrualId}`),
            $documentationReviewed = $form.find(`#DocumentationReviewedByBfm${accrualId}`),
            preparerData = {
                qid: qid,
                role: 'preparer',
                pin: '',
                pmNumber: accrualId
            },
            bfmData = {
                qid: qid,
                role: 'bfm_overview',
                pin: '',
                pmNumber: accrualId
            };

        checkDocumentationCheckboxes($documentationReviewed, bfmData)
            .then(() => checkDocumentationCheckboxes($documentationUploaded, preparerData))
            .then(() => {
                reloadPage(accrualId);
            })
            .catch((error) => {
                showErrorNotification(error);
            });
    });
}
const checkDocumentationCheckboxes = ($checkbox, data) => {
    return new Promise((resolve, reject) => {
        if ($checkbox.is(':visible')) {
            if ($checkbox.prop('checked')) {
                approveCheckboxApproval(data)
                    .then(() => {
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            } else {
                rejectCheckboxApproval(data)
                    .then(() => {
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            }
        } else {
            resolve();
        }
    });
}
const approveCheckboxApproval = (data) => {
    return new Promise((resolve, reject) => {
        let url = '';
        if (namePage === 'materialsequipmentaccrual') {
            url = '/Account/Accruals/MaterialApproval';
        } else if (namePage === 'subcontractaccrual') {
            url = '/Account/Accruals/SubContractApproval';
        } else {
            reject();
            return;
        }

        $.post(url, data, function (response) {
            if (response === true) {
                resolve();
            } else {
                reject(response);
            }
        });
    });
}
const rejectCheckboxApproval = (data) => {
    return new Promise((resolve, reject) => {
        let url = '';
        if (namePage === 'materialsequipmentaccrual') {
            url = '/Account/Accruals/RejectMaterialApproval';
        } else if (namePage === 'subcontractaccrual') {
            url = '/Account/Accruals/RejectSubContractApproval';
        } else {
            reject();
            return;
        }

        $.post(url, data, function (response) {
            if (response === true) {
                resolve();
            } else {
                reject(response);
            }
        });
    });
}
const setWindowData = () => {
    let $buttons = $('.js-additional-information-button [data-kendoWindow]'),
        $commentWindow = $('#AdditionalInformationWindow');

    if ($buttons.length) {
        //Unbind click events to prevent duplicate running
        $buttons.unbind('click');

        //Attach Event to add Window information;
        $buttons.on('click', function () {
            let $self = $(this),
                accrualId = $self.data('accrual-id'),
                isReply = $self.data('is-reply'),
                readOnly = $self.data('read-only');

            $commentWindow.data('accrual-id', accrualId);
            $commentWindow.data('apref', accrualId);
            $commentWindow.data('is-reply', isReply);
            $commentWindow.data('read-only', readOnly);
            // $commentWindow.data('kendoWindow').bind('activate', attachCommentSave);
        });
        // ReRun Kendo information
        $(document).trigger('on:PageUpdate');
    }
}
export const attachCommentSave = () => {
    let $sendBack = $('.js-send-back'),
        $sendReply = $('.js-send-reply');

    if ($sendBack.length) {
        $sendBack.unbind('click');
        $sendBack.on('click', function () {
            let $window = $('#AdditionalInformationWindow'),
                accrualId = $window.data('accrual-id');
            saveComment(accrualId)
                .then(_ => sendBackToPreparer(accrualId))
                .then(_ => {
                    closeKendoWindow($window);
                    reloadPage(accrualId);
                })
                .catch((error) => {
                    showErrorNotification(error);
                });
        })
    }
    if ($sendReply.length) {
        $sendReply.unbind('click');
        $sendReply.on('click', function () {
            let $window = $('#AdditionalInformationWindow'),
                accrualId = $window.data('accrual-id');
            saveComment(accrualId)
                .then(_ => {
                    closeKendoWindow($window);
                })
                .catch((error) => {
                    showErrorNotification(error);
                });
        });
    }
}
const saveComment = (accrualId) => {
    return new Promise((resolve, reject) => {
        let data = {
                accrualId: accrualId,
                apRefNumber: accrualId,
                comments: $('[name=AdditionalInformationComment]').val(),
                type: namePage
            },
            url = '/Account/Accruals/SaveAdditionInformationComments';
        if (namePage === 'sgaburdenother') {
            url = '/Finance/SaveSgaAdditionInformationComments'
        }
        $.post(url, data, function (response) {
            if (response === true) {
                resolve();
            } else {
                reject('Failed to Reject Approvals');
            }
        });
    });
}
const sendBackToPreparer = (accrualId) => {
    return new Promise((resolve, reject) => {
        let data = {
                accrualId: accrualId,
                apRefNumber: accrualId,
                type: namePage
            },
            url = '/Account/Accruals/RejectCorporateQuestions';
        if (namePage === 'sgaburdenother') {
            url = '/Finance/RejectSgaBurdenApproval';
            data.resetStarted = true;
        }

        $.post(url, data, function (response) {
            if (response === true) {
                resolve();
            } else {
                reject('Failed to Reject Approvals');
            }
        });
    })
}
const reloadPage = (accrualToReopen) => {
    if (namePage === 'materialsequipmentaccrual') {
        loadMaterialAccrual(accrualToReopen);
    } else if (namePage === 'subcontractaccrual') {
        loadSubContractAccrualData(accrualToReopen);
    }
}
const doQuestionValidation = (_this) => {
    let $self = $(_this),
        $form = $self.closest('form'),
        $corporateQuestions = $form.find('.js-corporate-questions'),
        $visibleQuestions = $corporateQuestions.find('.k-dropdown:visible, input:visible'),
        validated = true;

    $('.fieldValidationError').removeClass('fieldValidationError');

    if ($visibleQuestions.length) {
        $.each($visibleQuestions, function (index, ele) {
            let $dropdown = $(ele).find('input'),
                k_dropdown = null;

            if ($dropdown.length) {
                k_dropdown = $dropdown.data('kendoDropDownList');
            }

            if (k_dropdown) {
                if (k_dropdown.value() === '-1' || k_dropdown.value() === '') {
                    validated = false;
                    $(ele).addClass('fieldValidationError');
                }
            } else {
                if ($(ele).val() === '') {
                    validated = false;
                    $(ele).addClass('fieldValidationError');
                }
            }
        })
        return validated;
    }

    //No questions to save
    return true;
}
const endOfLineReached = (_this) => {
    let $self = $(_this),
        $form = $self.closest('form'),
        $corporateQuestions = $form.find('[data-question-top]'),
        $visibleQuestions = $corporateQuestions.find('.k-dropdown:visible, input:visible'),
        validated = true;

    if ($visibleQuestions.length) {
        $.each($visibleQuestions, function (index, ele) {
            let $dropdown = $(ele).find('input'),
                k_dropdown = null;

            if ($dropdown.length) {
                k_dropdown = $dropdown.data('kendoDropDownList');
            }

            if (k_dropdown) {
                if (k_dropdown.value() === '-1' || k_dropdown.value() === '') {
                    validated = false;
                }
            } else {
                if ($(ele).val() === '') {
                    validated = false;
                }
            }
        })
        return validated;
    }

    //No questions to save
    return true;
}